export var GLOBALS = {
  locale: {
    GB: 'gb',
    DE: 'de'
  },
  localeUpper: {
    GB: 'GB',
    DE: 'DE'
  },
  language: {
    EN: 'en',
    DE: 'de'
  },
  addressType: {
    HOME: 'HOME',
    BUSINESS: 'BUSINESS'
  },
  billingAddressType: {
    DIFFERENT: 'DifferentAddress',
    CURRENT: 'CurrentAddress'
  },
  country: {
    DE: 'DE',
    D: 'D',
    GB: 'GB'
  }
};
export var SCROLL_AMOUNTS = {
  monthTab: 146
};
export var MAX_ROOMS_SEARCH_LIMIT = 20;
export var PROD_ENVS = ['hulk', 'wanda'];
export var WB_SESSION_ID = 'WB-SESSION-ID';
export var ID_TOKEN_COOKIE = 'id_token_cookie';
export var DEFAULT_TRACING_COOKIE_NAME = 'WB-SESSION-ID';
export var MANUAL_ADDRESS = 'manualAddress';
export var REGISTER_BASKET_REF_COOKIE = 'register_basket_ref';
export var CONSENT_COOKIE = 'consent_cookie';
export var BASKET_IDS_COOKIE = 'basketIds';
export var BASKET_COOKIE_EXPIRY_HOURS = 1;
export var PAGE_UNAVAILABLE_URL_EN = 'page-unavailable.html';
export var PAGE_UNAVAILABLE_URL_DE = 'seite-nicht-verfuegbar.html';
export var TWO_MONTH_SEARCH = 'display_two_month_search';
export var BUNDLE_CHOICE = 'targetVariant';
export var BUNDLE_CHOICE_OPTIONS = {
  class: 'roomClass',
  rate: 'rate',
  noRoomTypeSearch: 'noRoomTypeSearch',
  roomOnly: 'roomOnly'
};
export var EXTRAS_ROOM_TAB_CHANGED = 'extras_room_tab_changed';
export var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export var BOOKING_REFERENCE_ID = 'booking_reference_id';
export var PIB_MANUAL_LOGOUT_FLAG = 'pib_manual_logout';
export var ONE_YEAR_IN_DAYS = 365;